import { useMemo } from 'react';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import {
  getCanDownloadNode,
  getCanShareNode,
  getIsFolderEmpty,
  getIsNodeFile,
  getIsNodeFolder,
  getNodeMimeType,
  getNodeSize,
  isVideo,
} from 'utils';

export default function useDataRoomDocument(node: DataRoomNode) {
  const isFile = getIsNodeFile(node);

  const isFolder = getIsNodeFolder(node);
  const isFolderEmpty = getIsFolderEmpty(node);

  const canShareNode = getCanShareNode(node);

  const isVideoFile = isVideo(getNodeMimeType(node));

  const nodeSize = getNodeSize(node);

  const canDownload = useMemo(() => getCanDownloadNode(node), [node]);

  return {
    isFile,
    isFolder,
    isFolderEmpty,
    isVideoFile,
    nodeSize,
    canDownload,
    canShareNode,
  };
}
